"use client";

import Link from "next/link";
import { useRouter } from "next/navigation";
import { useAuth } from "@/lib/auth";
import { Badge } from "./ui";

const ROLE_LABEL: Record<string, string> = {
  admin: "Админ",
  trainer: "Тренер",
  student: "Ученик",
};

function Logo() {
  return (
    <Link href="/" className="flex items-center gap-2">
      <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-brand text-brand-content">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden>
          <path d="M2 12L5 6L8 10L11 3L14 9" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </span>
      <span className="flex flex-col leading-none">
        <span className="font-display text-sm font-bold tracking-tight text-text">UPTIME</span>
        <span className="text-[10px] font-medium uppercase tracking-wide text-heritage">сделано в SmartBild</span>
      </span>
    </Link>
  );
}

export function NavBar({ isDark }: { isDark: boolean }) {
  const { me, isTrainer, isAdmin, logout } = useAuth();
  const router = useRouter();

  const linkClass = "text-sm text-text-muted transition-colors hover:text-text";
  const primaryRole = isAdmin ? "admin" : isTrainer ? "trainer" : "student";

  return (
    <header className="border-b border-border bg-surface">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3">
        <div className="flex items-center gap-8">
          <Logo />
          {!isDark && (
            <nav className="hidden items-center gap-6 sm:flex">
              <Link href="/#trainers" className={linkClass}>
                Тренеры
              </Link>
              <Link href="/#how-it-works" className={linkClass}>
                Как это работает
              </Link>
            </nav>
          )}
        </div>

        <nav className="flex items-center gap-4 text-sm">
          {me && isTrainer && (
            <Link href="/trainer" className={linkClass}>
              Кабинет тренера
            </Link>
          )}
          {me && isAdmin && (
            <Link href="/admin" className={linkClass}>
              Админка
            </Link>
          )}
          {me && !isDark && (
            <Link href="/bookings" className={linkClass}>
              Мои занятия
            </Link>
          )}
          {me && !isTrainer && !isDark && (
            <Link href="/diary" className={linkClass}>
              Дневник
            </Link>
          )}
          {me && (
            <Link href="/profile" className={`hidden sm:inline ${linkClass}`}>
              {me.phone}
            </Link>
          )}
          {me ? (
            <button
              onClick={() => {
                logout();
                router.push("/login");
              }}
              className="rounded-md border border-border px-3 py-1.5 text-text-muted transition-colors hover:border-text-muted hover:text-text"
            >
              Выйти
            </button>
          ) : (
            <Link
              href="/login"
              className="rounded-md bg-brand px-3 py-1.5 font-medium text-brand-content transition-opacity hover:opacity-90"
            >
              Войти
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
}
